export const appId = '1a51f8d1-abeb-4542-892b-748e678270ed';
export const apiKey = 'wZV5DRVBD+DIFmUrcNw4VWYCnKSeE1PixeLikCJHAcE=';
